module.exports = __webpack_public_path__ + "img/FT.0470c983.png";